<template>
  <a-tooltip background-color="var(--color-fill-1)" position="tr">
    <template #content>
      <Alert
        :style="{
          width: '327px',
          height: '60px',
        }"
        message="为了账户安全，币趣建议您经常更换钓鱼码"
      />
      <ul
        :style="{
          padding: '0',
          marginLeft: '10px',
          color: 'var(--color-text-1)',
        }"
      >
        <li>
          <p
            :style="{
              padding: '0',
            }"
            >什么是防钓鱼码？</p
          >
          <p
            :style="{
              fontSize: '12px',
              color: 'var(--color-text-4)',
            }"
            >防钓鱼码是你自己设置的一串字符，能够帮助你识别防冒币趣的网站或者邮件</p
          >
        </li>
        <li>
          <p>防钓鱼码会出现在哪？</p>
          <p
            :style="{
              fontSize: '12px',
              color: 'var(--color-text-4)',
            }"
            >设置好防钓鱼码后，每一封币趣发给您的邮件都会带有这串字符。</p
          >
        </li>
      </ul>
    </template>
    <slot name="text"></slot>
  </a-tooltip>
</template>

<script lang="ts" setup></script>

<style lang="less" scoped></style>
